export default __webpack_public_path__ + "./images/gf.2ad45500.png";